import { observer } from 'mobx-react';
import React from 'react';
import LoadingCogsLarge from '../../assets/Loading/Stodar_Loading_Cogs_Large-02.svg';
import LoadingCogsSmall from '../../assets/Loading/Stodar_Loading_Cogs_Small-03.svg';

@observer
export default class Loading extends React.Component {
    render() {
        return (
            <div className="loading">
                <img src={LoadingCogsLarge} alt="" className="cog-large" />
                <img src={LoadingCogsSmall} alt="" className="cog-small" />
            </div>)
    }
}